import {
  Card,
  CardBody,
  CardHead,
  Field,
  SearchableSelect,
  Textarea,
} from '../../components/ui';
import { ContextField } from './ContextField';
import { LANGUAGES, MAX_TEXT_CHARS, countParagraphs, countWords, paragraphWord } from './format';
import styles from './placement.module.css';

interface Props {
  text: string;
  onText: (value: string) => void;
  context: string;
  onContext: (value: string) => void;
  language: string;
  onLanguage: (value: string) => void;
  disabled: boolean;
}

export function ScriptStep({
  text,
  onText,
  context,
  onContext,
  language,
  onLanguage,
  disabled,
}: Props) {
  const chars = text.length;
  const paragraphs = countParagraphs(text);
  const words = countWords(text);
  const overLimit = chars > MAX_TEXT_CHARS;

  return (
    <Card>
      <CardHead index="01" title="Сценарий" />

      <CardBody pad className={styles.panelBody}>
        <ContextField value={context} onChange={onContext} disabled={disabled} />
      </CardBody>

      <label htmlFor="placement-text" className={styles.textLabel}>
        <span className={styles.textLabelTitle}>Текст под вставки</span>
        <span className={styles.hint}>пустая строка делит текст на части</span>
      </label>
      <p className={styles.textWarning}>
        Вставьте только фрагменты, где нужны футажи. Весь сценарий кладите в «Сценарий целиком»
        выше.
      </p>
      <Textarea
        id="placement-text"
        className={styles.script}
        value={text}
        onChange={(event) => onText(event.target.value)}
        disabled={disabled}
        spellCheck={false}
        placeholder="Вставьте текст, на который нужны футажи."
      />

      <CardBody pad className={styles.panelBody}>
        <div className={styles.fieldRow}>
          <Field layout="stacked" label="Язык текста">
            {() => (
              <SearchableSelect
                fullWidth
                options={[...LANGUAGES]}
                value={language}
                onChange={(next) => onLanguage(next ?? language)}
                disabled={disabled}
                ariaLabel="Язык текста"
              />
            )}
          </Field>

        </div>

      </CardBody>

      <div className={styles.panelFoot}>
        <span className={styles.counterRow}>
          <span className={overLimit ? styles.overLimit : undefined}>
            {chars.toLocaleString('ru-RU')} / {MAX_TEXT_CHARS.toLocaleString('ru-RU')} знаков
          </span>
          <span>·</span>
          <span>
            {words.toLocaleString('ru-RU')} слов · {paragraphs} {paragraphWord(paragraphs)}
          </span>
        </span>
        {overLimit && (
          <span className={styles.footHint}>
            «Текст под вставки» длиннее лимита, разбейте его на части.
          </span>
        )}
      </div>
    </Card>
  );
}
